export * from "./Select.settings";
